export const Back = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="50" height="50" rx="25" fill="#EBEBEB" />
      <path
        d="M13.8335 25.5L12.8023 24.4688L11.7711 25.5L12.8023 26.5312L13.8335 25.5ZM35.7085 26.9583C36.5139 26.9583 37.1668 26.3054 37.1668 25.5C37.1668 24.6946 36.5139 24.0417 35.7085 24.0417V26.9583ZM22.5835 16.75L21.5523 15.7188L12.8023 24.4688L13.8335 25.5L14.8647 26.5312L23.6147 17.7812L22.5835 16.75ZM13.8335 25.5L12.8023 26.5312L21.5523 35.2812L22.5835 34.25L23.6147 33.2188L14.8647 24.4688L13.8335 25.5ZM13.8335 25.5V26.9583H35.7085V25.5V24.0417H13.8335V25.5Z"
        fill="#33363F"
      />
    </svg>
  );
};
